/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Type_SaleInputs */

const vi_customer_debt_type_sale = /** @type {(inputs: Customer_Debt_Type_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán`)
};

/**

* @param {Customer_Debt_Type_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_type_sale = /** @type {((inputs?: Customer_Debt_Type_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Type_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_type_sale(inputs)
});